var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"control control--checkboxes"},_vm._l((_vm.vacationTypes),function(item,index){return _c('string-item',{key:index,staticClass:"content",attrs:{"item":item,"checked":_vm.isCheckedVacationType(item)},on:{"change":function($event){return _vm.checkItem(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }